<template>
  <div class="my-account">
    <PageTitle title="My Account" subtitle="Here's an Account Page" />
  </div>
</template>

<script>
import PageTitle from "../components/blocks/PageTitle";

export default {
  components: {
    PageTitle,
  },
};
</script>

<style></style>
